import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { FolderOpenIcon, IconSize, IconWrapper, Link, LinkSize } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { PreInterviewPreviewModalOpener } from '../../../preInterview/preview/PreInterviewPreviewModal.opener';

type PreInterviewPreviewLinkProps = {
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientFullName: string;
   readonly patientId: number;
   readonly visitId: number | undefined;
   readonly visitStatus: VisitAndAppointmentStatus;
};

export const PreInterviewPreviewLink = (props: PreInterviewPreviewLinkProps): JSX.Element => {
   return (
      <PreInterviewPreviewModalOpener
         appointmentId={props.appointmentId}
         beginDate={props.beginDate}
         endDate={props.endDate}
         patientFullName={props.patientFullName}
         patientId={props.patientId}
         visitId={props.visitId}
         visitStatus={props.visitStatus}
      >
         {({ openModal }) => (
            <Link
               testId={'preInterviewPreview'}
               label={appointmentsTranslationKeys.preInterview.table.column.actions.preview}
               size={LinkSize.NORMAL}
               onClick={openModal}
               icon={
                  <IconWrapper testId={'previewIcon'} size={IconSize.LARGE}>
                     <FolderOpenIcon />
                  </IconWrapper>
               }
            />
         )}
      </PreInterviewPreviewModalOpener>
   );
};
